import React from 'react';
import image from "../../../assets/img/about/about-1.jpg";
import videoBg from "../../../assets/img/shape/shape.png";
import Count from '../../common/count';
import { Link } from 'react-router-dom';

const ChooseUs = () => {
    const points = [
        "Government Registered E-Grade Company",
        "Experienced in Civil Infrastructure Work",
        "Focus on Quality and Durability",
        "Timely Project Execution",
        "Professional Site Management",
        "Commitment to Public Development"
    ];

    return (
        <div className="choose__us section-padding">
            <div className="container">
                <div className="row al-center">
                    <div className="col-xl-6 xl-mb-25">
                        <div className="choose__us-left t-right mr-40 xl-mr-0">
                            <img className="wow img_left_animation" src={image} alt="image" />
                            {/* <div className="choose__us-left-counter bounce_x" style={{backgroundImage: `url(${videoBg})`}}>
                                <h2><Count number={156}/>k</h2>
                                <p>Project Completed</p>
                            </div> */}
                        </div>
                    </div>
                    <div className="col-xl-6">
                        <div className="choose__us-right ml-30 xl-ml-0">
                            <div className="choose__us-right-title mb-40">
                                <span className="subtitle wow fadeInLeft" data-wow-delay=".4s">Why Choose US</span>
                                <h2 className="mb-30 wow fadeInRight" data-wow-delay=".6s">Why Choose Arclight Developers?</h2>
                            </div>
                            <div className="choose__us-right-list wow fadeInUp" data-wow-delay=".7s">
                                <ul style={{ listStyleType: 'none', padding: 0 }}>
                                    {points.map((point, index) => (
                                        <li key={index} style={{ marginBottom: '15px', fontSize: '18px', fontWeight: '500' }}>
                                            <i className="fas fa-check-circle" style={{ color: '#ff5e14', marginRight: '10px' }}></i>
                                            {point}
                                        </li>
                                    ))}
                                </ul>
                            </div>
                            <div className="wow fadeInDown" data-wow-delay="1.2s">
                                <Link className="build_button mt-50" to="/contact-us">Start Today<i className="flaticon-right-up"></i></Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ChooseUs;